import React, {
  useEffect,
  useState,
} from 'react'
import InputBase from './InputBase'

import {
  AddLink,
  CountText,
  ErrorText,
  FooterContainer,
  FormControl,
  FormLabel,
  HeaderContainer,
  RequiredContent,
} from './styles'


export interface ISharedProps {
  value: string
  type?: string
  max?: number
  disabled?: boolean
  error?: boolean
  required?: boolean
  success?: number
}

export interface ITextFieldProps extends ISharedProps {
  setvalue?: (value: string | number) => void
  header?: IHeaderProps,
  onChange?: (value: string | number) => void
  input: {
    placeholder: string,
    starticon: JSX.Element,
  }
  footer?: IFooterProps
  width?: string
}

export interface IFooterProps extends ISharedProps{
  error: boolean
  errorLabel?: string
  hasCount?: boolean
  setvalue?: (value: string) => void
}

export interface IHeaderProps extends ISharedProps{
  label?: string
  addLabel?: string
  onAdd?: (event: React.MouseEvent<HTMLDivElement>) => void
  setvalue?: (value: string) => void
}

const Header = ({ required, label, addLabel, onAdd, ...props }: IHeaderProps) =>
  required || label || addLabel ? (
    <HeaderContainer {...props}>
      {required && <RequiredContent>*</RequiredContent>}
      <FormLabel required={false}>{label}</FormLabel>
      {addLabel && <AddLink onClick={onAdd}>{addLabel}</AddLink>}
    </HeaderContainer>
  ) : null

const Footer = ({
  value,
  error,
  errorLabel,
  hasCount = false,
  max,
  ...props
}: IFooterProps) => {
  const [count, setCount] = useState('')

  useEffect(() => {
    if (max) {
      setCount(`${value?.length || 0}/${max}`)
    } else {
      setCount(`${value?.length || 0}`)
    }
  }, [value])

  if (error || hasCount) {
    return (
      <FooterContainer {...props}>
        <ErrorText>{error ? errorLabel : ''}</ErrorText>
        {hasCount && <CountText>{count}</CountText>}
      </FooterContainer>
    )
  }
  return null
}
const TextField = React.forwardRef(
  (
    inputProps: ITextFieldProps,
    ref,
  ) => {
    const {
      value,
      setvalue,
      header,
      input,
      footer,
      type,
      max,
      disabled = false,
      error = false,
      required = false,
      success = 0,
      width,
      onChange,
      ...props
    } = inputProps

    const [lengthError, setLengthError] = useState(false)

    const sharedProps = {
      type,
      max,
      disabled,
      error: error || lengthError,
      required,
      success: +success,
    }

    useEffect(() => {
      if (max) {
        setLengthError(value?.length > max)
      }
    }, [value])

    return (
      <FormControl width={width} {...sharedProps} {...props}>
        <Header
          value={value}
          setvalue={setvalue}
          {...sharedProps}
          {...header}
        />
        <InputBase
          value={value}
          setvalue={setvalue}
          onChange={onChange}
          {...sharedProps}
          {...input}
          ref={ref}
        />
        <Footer
          value={value}
          setvalue={setvalue}
          {...sharedProps}
          {...footer}
        />
      </FormControl>
    )
  },
)
export default TextField
